<template>
  <main class="how-we-work">
    <AppSection
      class="hero"
      :data="{
        img: { src: '/assets/video/how-we-work_0.jpg' },
        video: { src: '/assets/video/how-we-work_0.mp4' },
      }"
    >
      <AppHeadline
        class="hero__headline"
        :data="{
          content: howWeWork.hero.title,
          type: 2,
        }"
      />
      <div class="hero__content-container">
        <AppParagraph class="hero__text"
          :data="{
            content: howWeWork.hero.content[0],
          }"
        />
        <span class="section__line hero__line"></span>
        <AppParagraph class="hero__text"
          :data="{
            content: howWeWork.hero.content[1],
          }"
        />
      </div>
    </AppSection>

    <AppSection
      class="intro"
      :data="{
        img: { src: howWeWork.intro.img.src },
      }"
    >
      <img
        class="intro__shooting-star"
        data-star="0"
        src="/assets/img/home/shooting-star_1.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="1"
        src="/assets/img/home/shooting-star_2.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="2"
        src="/assets/img/home/shooting-star_1.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="3"
        src="/assets/img/home/shooting-star_2.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="4"
        src="/assets/img/home/shooting-star_1.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="5"
        src="/assets/img/home/shooting-star_2.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="6"
        src="/assets/img/home/shooting-star_1.png"
        alt="shooting-star"
      >
      <img
        class="intro__shooting-star"
        data-star="7"
        src="/assets/img/home/shooting-star_2.png"
        alt="shooting-star"
      >
      <AppHeadline
        class="intro__headline"
        :data="{
          content: howWeWork.intro.title,
          type: 2,
        }"
      />
      <ul class="intro__content-container">
        <li
          class="intro__text"
          v-for="(item, i) in howWeWork.intro.content"
          :key="`intro-${i}`"
        >
          <AppHeadline
            class="intro__content-headline"
            :data="{
              content: item.title,
              type: 3,
            }"
          />
          <AppParagraph class="intro__content"
            :data="{
              content: item.content,
            }"
          />
        </li>
      </ul>
    </AppSection>

    <AppSection
      class="first-section"
      :data="{
        img: { src: howWeWork.firstBlock.img.src },
      }"
    >
      <span
        class="first-section__sphere"
        :style="{
          backgroundImage: `url('/assets/svg/sphere${isSafari() ? '-safari' : ''}.svg')`,
        }"
      />
      <AppHeadline
        class="first-section__headline"
        :data="{
          content: howWeWork.firstBlock.title,
          type: 2,
        }"
      />
      <div
        class="first-section__content-container first-section__text"
        v-for="(item, i) in howWeWork.firstBlock.content"
        :key="`first-section-${i}`"
      >
        <AppHeadline
          class="first-section__content-headline"
          :data="{
            content: item.title,
            type: 3,
          }"
        />
        <AppParagraph
          :data="{
            content: item.content,
          }"
        />
      </div>
    </AppSection>

    <AppSection
      class="second-section"
      :data="{
        img: { src: '/assets/video/how-we-work_1.jpg' },
        video: { src: '/assets/video/how-we-work_1.m4v' },
      }"
    >
      <AppHeadline
        class="second-section__headline"
        :data="{
          content: howWeWork.secondBlock.title,
          type: 2,
        }"
      />
      <span class="section__line second-section__line"></span>
      <ul class="second-section__content-container">
        <li
          class="second-section__text"
          v-for="(item, i) in howWeWork.secondBlock.content"
          :key="`item-${i}`"
        >
          <span class="second-section__number-container">
            <AppHeadline
              class="second-section__number"
              :data="{
                content: i + 1,
                type: 3,
              }"
            />
          </span>
          <AppHeadline
            class="second-section__content"
            :data="{
              content: item,
              type: 3,
            }"
          />
        </li>
      </ul>
    </AppSection>

    <AppSection
      class="third-section"
      :data="{
        img: { src: howWeWork.thirdBlock.img.src },
      }"
    >
      <AppHeadline
        class="third-section__headline"
        :data="{
          content: howWeWork.thirdBlock.title,
          type: 2,
        }"
      />
      <div class="third-section__content-container">
        <AppParagraph
          class="third-section__text"
          v-for="(item, i) in howWeWork.thirdBlock.content"
          :key="`third-section-${i}`"
          :data="{
            content: howWeWork.thirdBlock.content[i],
          }"
        />
      </div>
    </AppSection>

    <AppSection
      class="fourth-section"
      :data="{
        img: { src: '/assets/video/how-we-work_2.jpg' },
        video: { src: '/assets/video/how-we-work_2.mp4' },
      }"
    >
      <span
        class="fourth-section__sphere"
        :style="{
          backgroundImage: `url('/assets/svg/sphere${isSafari() ? '-safari' : ''}.svg')`,
        }"
      />
      <AppHeadline
        class="fourth-section__headline"
        :data="{
          content: howWeWork.fourthBlock.title,
          type: 2,
        }"
      />
      <div
        class="fourth-section__block"
        v-for="(item, i) in howWeWork.fourthBlock.lists"
        :key="`fourth-section-${i}`"
      >
        <AppHeadline
          class="fourth-section__block-headline"
          :data="{
            content: item.title,
            type: 3,
          }"
        />
        <span class="section__line fourth-section__line"></span>
        <ul class="fourth-section__block-list">
          <li
            v-for="(subitem, i) in item.content"
            :key="`fourth-section-sub-${i}`"
          >
            <AppParagraph
              :data="{
                content: `${i + 1}. ${subitem}`,
              }"
            />
          </li>
        </ul>
      </div>
    </AppSection>

    <AppSection
      class="fifth-section"
      :data="{
        img: { src: howWeWork.fifthBlock.img.src },
      }"
    >
      <div class="fifth-section__content-container">
        <AppHeadline
          class="fifth-section__headline"
          :data="{
            content: howWeWork.fifthBlock.title,
            type: 2,
          }"
        />
        <span class="section__line fifth-section__line"></span>
        <AppParagraph
          class="fifth-section__text"
          :data="{
            content: howWeWork.fifthBlock.content,
          }"
        />
      </div>
      <div class="fifth-section__block">
        <ul>
          <li
            class="fifth-section__logo"
            v-for="(item, i) in howWeWork.fifthBlock.list"
            :key="`logo-${i}`"
          >
            <img :src="item.src" :alt="item.alt">
          </li>
        </ul>
      </div>
    </AppSection>

    <AppSection
      class="sixth-section"
      :data="{
        img: { src: '/assets/video/how-we-work_3.jpg' },
        video: { src: '/assets/video/how-we-work_3.m4v' },
      }"
    >
      <div class="sixth-section__content-container">
        <AppHeadline
          class="sixth-section__headline"
          :data="{
            content: howWeWork.sixthBlock.title,
            type: 2,
          }"
        />
        <span class="section__line sixth-section__line"></span>
        <AppHeadline
          class="sixth-section__subheadline"
          :data="{
            content: howWeWork.sixthBlock.subtitle,
            type: 3,
          }"
        />
        <ul class="sixth-section__content-list">
          <li
            class="sixth-section__list-item"
            v-for="(item, i) in howWeWork.sixthBlock.content"
            :key="`sixth-section-sub-${i}`"
          >
            <AppParagraph
              :data="{
                content: item,
              }"
            />
          </li>
        </ul>
      </div>
    </AppSection>

    <AppFooter />
  </main>
</template>

<script>
import { TweenMax, TimelineMax, Power4 } from 'gsap/TweenMax';
import IScroll from 'iscroll/build/iscroll-probe';
import scrollMagic from '@/scripts/scrollMagic';
import { isMobile } from '@/scripts/utils';

import AppSection from '@/components/AppSection.vue';
import AppHeadline from '@/components/AppHeadline.vue';
import AppParagraph from '@/components/AppParagraph.vue';
import AppFooter from '@/components/AppFooter.vue';

import howWeWork from '@/assets/data/howWeWork.json';

export default {
  name: 'howWeWork',
  components: {
    AppSection,
    AppHeadline,
    AppParagraph,
    AppFooter,
  },
  data() {
    return {
      howWeWork,
    };
  },
  mounted() {
    this.init();
    this.enter();

    // init controller
    this.controller = new scrollMagic.Controller({ container: '.app__container--how-we-work' });
    this.intro();
    this.firstSection();
    this.secondSection();
    this.thirdSection();
    this.fourthSection();
    this.fifthSection();
    this.sixthSection();

    if (isMobile()) {
      // configure iScroll
      this.myScroll = new IScroll('.app__container', {
        scrollX: false,
        scrollY: true,
        scrollbars: true,
        useTransform: false,
        useTransition: false,
        probeType: 3,
        click: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false,
      });

      this.controller.scrollPos(() => -this.myScroll.y);

      this.handlerScroll = () => this.controller.update(true);
      this.myScroll.on('scroll', this.handlerScroll);
    }
  },
  methods: {
    isSafari() {
      return navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') < 0;
    },
    init() {
      TweenMax.set('.hero .section__bg', { autoAlpha: 0, scale: 1.5 });
      TweenMax.set('.hero .hero__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.hero .hero__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.hero .hero__text', { autoAlpha: 0, y: 50 });
    },
    enter() {
      const tl = new TimelineMax({ delay: 0.5 });
      const texts = Array.from(this.$el.querySelectorAll('.hero .hero__text'));

      tl.addLabel('start')
        .to('.hero .section__bg', 2, {
          autoAlpha: 1,
          scale: 1,
          ease: Power4.easeOut,
        }, 'start')
        .to('.hero__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to(texts[0], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start+=0.25')
        .to('.hero__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start+=0.5')
        .to(texts[1], 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start+=0.75');
    },
    intro() {
      const texts = Array.from(this.$el.querySelectorAll('.intro .intro__text'));
      TweenMax.set(texts, { y: 50, yPercent: -50, autoAlpha: 0 });
      TweenMax.set(texts[0], { y: 50, yPercent: 0, autoAlpha: 0 });
      texts.pop();
      const stars = Array.from(this.$el.querySelectorAll('.intro .intro__shooting-star'));
      TweenMax.set(stars, { autoAlpha: 0, x: -75, y: 75 });
      const lastStars = stars.splice(6, 2);
      TweenMax.set('.intro .intro__headline', { autoAlpha: 0, y: 50 });
      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.intro__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .staggerTo('.intro__text', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 2, 'start+=0.5')
        .staggerTo(texts, 1, {
          autoAlpha: 0,
          y: -50,
          ease: Power4.easeInOut,
        }, 2, 'start+=2')
        .staggerTo(stars, 1.4, {
          x: 75,
          y: -75,
        }, 2, 'start+=0.5')
        .staggerTo(stars, 0.7, {
          autoAlpha: 0.5,
        }, 2, 'start+=0.5')
        .staggerTo(stars, 0.7, {
          autoAlpha: 0,
        }, 2, 'start+=1.2')
        .staggerTo(lastStars, 1.4, {
          x: 75,
          y: -75,
        }, 0.3, 'start+=10.5')
        .staggerTo(lastStars, 0.7, {
          autoAlpha: 0.5,
        }, 0.5, 'start+=10.5')
        .staggerTo(lastStars, 0.7, {
          autoAlpha: 0,
        }, 0.5, 'start+=11.2');

      this.introScene = new scrollMagic.Scene({
        duration: 4000,
        offset: window.innerHeight,
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    firstSection() {
      const texts = Array.from(this.$el.querySelectorAll('.first-section .first-section__text'));
      TweenMax.set('.first-section__sphere', {
        webkitClipPath: 'inset(100% 0.03% 0.02% 0)',
        clipPath: 'inset(100% 0.03% 0.02% 0)',
      });
      TweenMax.set('.first-section .first-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set(texts, { autoAlpha: 0, y: 50 });
      TweenMax.set('.first-section .section__bg', { scale: 1.2 });

      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.first-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .staggerTo('.first-section .section__bg', 2.5, {
          scale: 1,
          ease: Power4.easeInOut,
        }, 1.5, 'start+=0.25')
        .to('.first-section__sphere', 2.5, {
          webkitClipPath: 'inset(0.01% 0.02% 0% 0.03%)',
          clipPath: 'inset(0.01% 0.02% 0% 0.03%)',
          ease: Power4.easeInOut,
        }, 'start+=0.25')
        .staggerTo(texts, 1.5, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 1, 'start+=0.25');

      this.firstScene = new scrollMagic.Scene({
        duration: 2000,
        offset: 4000 + (window.innerHeight * 2),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    secondSection() {
      const texts = Array.from(this.$el.querySelectorAll('.second-section .second-section__text'));
      texts.pop();
      TweenMax.set('.second-section .second-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.second-section .second-section__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.second-section .second-section__text', { y: 25, autoAlpha: 0 });
      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.second-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.second-section__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .staggerTo('.second-section__text', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 3, 'start+=0.5')
        .staggerTo(texts, 1, {
          autoAlpha: 0,
          y: -25,
          ease: Power4.easeInOut,
        }, 3, 'start+=3');

      this.secondScene = new scrollMagic.Scene({
        duration: 6000,
        offset: 6000 + (window.innerHeight * 3),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    thirdSection() {
      const texts = Array.from(this.$el.querySelectorAll('.third-section .third-section__text'));
      texts.pop();
      TweenMax.set('.third-section .third-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.third-section .third-section__text', { y: 50, autoAlpha: 0 });
      TweenMax.set('.third-section .section__bg', { transformOrigin: '50% 0%' });
      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.third-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .staggerTo('.third-section__text', 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeInOut,
        }, 2, 'start+=0.25')
        .staggerTo(texts, 1, {
          autoAlpha: 0,
          y: -50,
          ease: Power4.easeInOut,
        }, 2, 'start+=2')
        .to('.third-section .section__bg', 6.2, {
          scale: 1.2,
          ease: Power4.easeInOut,
        }, 'start+=0.25');

      this.thirdScene = new scrollMagic.Scene({
        duration: 2000,
        offset: 12000 + (window.innerHeight * 4),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    fourthSection() {
      const blockTitles = Array.from(this.$el.querySelectorAll('.fourth-section__block-headline'));
      const blocks = Array.from(this.$el.querySelectorAll('.fourth-section__block'));
      const lists = Array.from(this.$el.querySelectorAll('.fourth-section__block-list'));
      const firstHeadline = blocks[0].querySelector('.fourth-section__block-headline');
      const firstLine = blocks[0].querySelector('.fourth-section__line');
      const firstListItems = Array.from(lists[0].querySelectorAll('li'));
      const secondHeadline = blocks[1].querySelector('.fourth-section__block-headline');
      const secondLine = blocks[1].querySelector('.fourth-section__line');
      const secondListItems = Array.from(lists[1].querySelectorAll('li'));

      TweenMax.set('.fourth-section .fourth-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set(blockTitles, { autoAlpha: 0, y: 50 });
      TweenMax.set(firstLine, { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set(firstListItems, { autoAlpha: 0, y: 50 });
      TweenMax.set(secondHeadline, { autoAlpha: 0, y: 50 });
      TweenMax.set(secondLine, { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set(secondListItems, { autoAlpha: 0, y: 50 });
      TweenMax.set('.fourth-section__sphere', {
        webkitClipPath: 'inset(0.01% 0% 100% 0.02%)',
        clipPath: 'inset(0.01% 0% 100% 0.02%)',
      });

      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.fourth-section .fourth-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.fourth-section__sphere', 1, {
          webkitClipPath: 'inset(0.01% 0% 0.03% 0.02%)',
          clipPath: 'inset(0.01% 0% 0.03% 0.02%)',
          ease: Power4.easeOut,
        }, 'start')
        .to('.fourth-section .fourth-section__headline', 1, {
          y: -50,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        }, 'start+=1.25')
        .to('.fourth-section__sphere', 2, {
          rotation: 90,
        }, 'start+=1.25')
        .to(firstHeadline, 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
        }, 'start+=2')
        .to(firstLine, 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=2.25')
        .staggerTo(firstListItems, 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
        }, 0.08, 'start+=2.5')
        .to(blocks[0], 1, {
          autoAlpha: 0,
          y: -50,
          ease: Power4.easeOut,
        }, 'start+=3.75')
        .to(secondHeadline, 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
        }, 'start+=4')
        .to(secondLine, 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=4.25')
        .staggerTo(secondListItems, 1, {
          autoAlpha: 1,
          y: 0,
          ease: Power4.easeOut,
        }, 0.08, 'start+=4.5');

      this.fourthScene = new scrollMagic.Scene({
        duration: 2000,
        offset: 14000 + (window.innerHeight * 5),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    fifthSection() {
      TweenMax.set('.fifth-section .fifth-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.fifth-section .section__bg', { transformOrigin: '100% 0%' });
      TweenMax.set('.fifth-section .fifth-section__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.fifth-section .fifth-section__text', { autoAlpha: 0, y: 50 });
      TweenMax.set('.fifth-section .fifth-section__logo', { autoAlpha: 0, y: 50 });

      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.fifth-section .fifth-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.fifth-section__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .to('.fifth-section .fifth-section__text', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeInOut,
          clearProps: 'all',
        }, 'start+=0.50')
        .to('.fifth-section .section__bg', 2.5, {
          scale: 1.25,
          ease: Power4.easeInOut,
        }, 'start+=2')
        .to('.fifth-section .fifth-section__content-container', 1, {
          y: -50,
          autoAlpha: 0,
          ease: Power4.easeInOut,
        }, 'start+=2')
        .staggerTo('.fifth-section .fifth-section__logo', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeInOut,
        }, 0.2, 'start+=2.5');

      this.fifthScene = new scrollMagic.Scene({
        duration: 2000,
        offset: 16000 + (window.innerHeight * 6),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
    sixthSection() {
      TweenMax.set('.sixth-section .sixth-section__content-container', { y: 150 });
      TweenMax.set('.sixth-section .sixth-section__headline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.sixth-section .sixth-section__line', { scaleY: 0, transformOrigin: '50% 0' });
      TweenMax.set('.sixth-section .sixth-section__subheadline', { autoAlpha: 0, y: 50 });
      TweenMax.set('.sixth-section .sixth-section__list-item', { autoAlpha: 0, y: 50 });

      const tl = new TimelineMax();

      tl.addLabel('start')
        .to('.sixth-section .sixth-section__headline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeOut,
          clearProps: 'all',
        }, 'start')
        .to('.sixth-section__line', 1, {
          scaleY: 1,
          ease: Power4.easeOut,
        }, 'start+=0.25')
        .to('.sixth-section .sixth-section__subheadline', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeInOut,
          clearProps: 'all',
        }, 'start+=0.50')
        .to('.sixth-section .sixth-section__content-container', 6, {
          y: -100,
          ease: Power4.easeInOut,
        }, 'start')
        .staggerTo('.sixth-section .sixth-section__list-item', 1, {
          y: 0,
          autoAlpha: 1,
          ease: Power4.easeInOut,
        }, 0.2, 'start+=2.5')
        .to('.sixth-section .sixth-section__headline', 1, {
          autoAlpha: 0.1,
          ease: Power4.easeOut,
        }, 'start+=2.5')
        .to('.sixth-section__line', 1, {
          autoAlpha: 0.3,
          ease: Power4.easeOut,
        }, 'start+=2.75')
        .to('.sixth-section .sixth-section__subheadline', 1, {
          autoAlpha: 0.6,
          ease: Power4.easeInOut,
        }, 'start+=3.0');

      this.sixthScene = new scrollMagic.Scene({
        duration: 3500,
        offset: 18000 + (window.innerHeight * 7),
      })
        .setTween(tl)
        .setPin('.how-we-work')
        .addTo(this.controller);
    },
  },
  beforeDestroy() {
    if (isMobile() && navigator.userAgent.indexOf('OS 13_') < 0 && navigator.userAgent.indexOf('Safari') > 0) {
      this.myScroll.off('scroll', this.handlerScroll);
      this.myScroll.destroy();
      this.myScroll = null;
    }
    this.controller.destroy();
    this.controller = null;
    this.introScene.destroy();
    this.introScene = null;
    this.firstScene.destroy();
    this.firstScene = null;
    this.secondScene.destroy();
    this.secondScene = null;
    this.thirdScene.destroy();
    this.thirdScene = null;
    this.fourthScene.destroy();
    this.fourthScene = null;
    this.fifthScene.destroy();
    this.fifthScene = null;
    this.sixthScene.destroy();
    this.sixthScene = null;
  },
};
</script>

<style lang="scss" scoped>
.how-we-work {
  .intro__container,
  .first-block,
  .second-block,
  .second-section,
  .fourth-section,
  .fourth-section__block,
  .sixth-section {
    align-items: center;
    justify-content: center;
    flex-flow: column nowrap;
  }

  .hero,
  .intro,
  .third-block,
  .fourth-block,
  .fourth-block__second-section,
  .fifth-block__second-section,
  .first-section,
  .third-section {
    align-items: center;
    justify-content: space-between;

    @include mq($until: ipadL) {
      justify-content: center;
      flex-flow: column nowrap;
    }
  }

  .fifth-section {
    align-items: center;
    justify-content: flex-end;
  }

  .intro__content-headline,
  .first-section__content-headline {
    margin-bottom: 25px;
  }

  .hero {
    &__content-container {
      max-width: 350px;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;
    }

    @include mq($until: ipadL) {
      .hero__headline {
        margin-bottom: 35px;
      }

      text-align: center;
    }
  }

  .intro {
    &__content-container {
      position: relative;
      max-width: 350px;
      text-align: center;

      li {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;

        transform: translateY(-50%);

        &:first-child {
          position: relative;
          top: unset;
          left: unset;

          transform: none;
        }
      }
    }

    @include mq($until: ipadL) {
      .intro__headline {
        margin-bottom: 35px;
      }
    }

    &__shooting-star {
      position: absolute;

      &[data-star="0"] {
        top: 15vh;
        left: 25vw;
      }

      &[data-star="1"] {
        bottom: 15vh;
        left: 30vw;
      }

      &[data-star="2"] {
        top: calc(50vh - 40px);
        left: 45vw;
      }

      &[data-star="3"] {
        top: 15vh;
        left: 15vw;
      }

      &[data-star="4"] {
        bottom: 10vh;
        left: 25vw;
      }

      &[data-star="5"] {
        bottom: 25vh;
        left: 10vw;
      }

      &[data-star="6"] {
        top: 20vh;
        left: 50vw;
      }

      &[data-star="7"] {
        bottom: 10vh;
        right: 15vw;
      }
    }
  }

  .first-section {
    &__sphere {
      position: absolute;
      top: 50%;
      left: 50%;
      height: calc(100vw + 50px);
      width: calc(100vw + 50px);

      transform: translateX(-50%) translateY(-50%) rotate(90deg);
      transform-origin: 50% 50%;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

      @include mq(ipadL) {
        height: calc(100vh + 50px);
        width: calc(100vh + 50px);
      }
    }

    &__headline{
      position: relative;
      width: 100%;

      @include mq(ipadL) {
        position: absolute;
        top: 20vh;
        left: 0;
      }
    }

    &__content-container {
      max-width: 350px;
      text-align: center;
    }

    @include mq($until: ipadL) {
      .first-section__headline,
      .first-section__text {
        margin-bottom: 35px;
      }
    }
  }

  .second-section {
    flex-flow: column nowrap;

    &__content-container {
      position: relative;
      width: 100%;
      text-align: center;

      li {
        position: absolute;
        top: 0;
        left: 50%;
        width: 100%;

        transform: translateX(-50%);

        &:first-child {
          position: relative;
          top: unset;
          left: unset;

          transform: none;
        }
      }
    }

    &__number {
      display: inline-block;
      position: relative;
      width: 40px;
      margin-right: 25px;

      text-align: center;

      @include mq($until: ipadL) {
        margin-bottom: 25px;
        margin-right: 0;
      }

      &::before {
        display: block;
        content: '';

        position: absolute;
        width: 40px;
        height: 40px;
        top: 50%;
        left: 50%;

        transform: translateX(-50%) translateY(-50%);

        border-radius: 50%;
        border: 1px solid $color-white;

        @include mq(ipadL) {
          width: 50px;
          height: 50px;
        }
      }
    }

    &__content {
      display: inline-block;

      @include mq($until: ipadL) {
        width: 100%;
      }
    }
  }

  .third-section {
    &__content-container {
      position: relative;
      max-width: 350px;
    }

    &__headline {
      @include mq($until: ipadL) {
        margin-bottom: 25px;
      }
    }

    &__text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;

      &:first-child {
        position: relative;
      }

      @include mq($until: ipadL) {
        text-align: center;
      }
    }
  }

  .fourth-section {
    &__sphere {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 85vw;
      width: 85vw;

      transform: translateX(-50%) translateY(-50%);
      transform-origin: 50% 50%;

      background-position: center center;
      background-repeat: no-repeat;
      background-size: cover;

      @include mq(ipadL) {
        height: 80vh;
        width: 80vh;
      }
    }

    &__block {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      display: flex;

      text-align: center;
    }

    li {
      margin-top: 15px;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .fifth-section {
    &__content-container {
      text-align: center;
      max-width: 450px;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;
    }

    &__block {
      position: absolute;
      top: 50%;
      right: 20px;
      width: calc(100% - 40px);

      transform: translateY(-50%);

      @include mq(ipadL) {
        width: 50%;
        right: 80px;
      }

      ul {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-flow: row wrap;
      }

      li {
        display: inline-block;
        flex: 0 0 40%;
        width: 40%;
        margin-left: 5%;
        margin-right: 5%;
        margin-bottom: 60px;
        height: auto;

        @include mq(ipadL) {
          margin-left: 5%;
          flex: 0 0 20%;
          width: 20%;
        }

        img {
          width: 120px;
          height: auto;
          box-sizing: border-box;
        }
      }
    }
  }

  .sixth-section {
    &__content-container,
    &__content-list li {
      max-width: 350px;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column nowrap;
    }

    &__content-list {
      text-align: center;
      margin-top: 50px;

      li::after {
        content: '';
        display: block;

        position: relative;
        width: 1px;
        height: 18px;
        margin: 10px 0;

        background-color: $color-white;
      }

      li:last-child::after {
        content: none;
      }
    }
  }
}
</style>
